import { Pagination, PaginationItem } from "@mui/material";
import { DisplayParams } from "../types/classes/DisplayParams";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export function CphPagination({ pageCount, displayParams, onPageChange }: {pageCount: number, displayParams: DisplayParams, onPageChange: (displayParams: DisplayParams) => void}) {

    const handleChange = (_: unknown, value: number) => {
        const newDisplayParams: DisplayParams = new DisplayParams();
        newDisplayParams.Page = value;
        newDisplayParams.ShowDetailFlag = true;
        onPageChange(newDisplayParams);
    };

    return (
        <Pagination size="medium" count={pageCount} page={displayParams.Page} onChange={handleChange} variant="outlined" 
            showFirstButton showLastButton
            renderItem={(item) => (
                <PaginationItem
                    slots={{ 
                        first: KeyboardDoubleArrowLeftIcon,
                        last: KeyboardDoubleArrowRightIcon
                    }}
                    {...item}
                />
            )}
        />
    );
}